import { getInitialState } from './index';
import { State, EventHubPages, Params, SortBy, FilterBy } from './types';

const mutations = {
  setEventHubPages(state: State, eventHubPages: EventHubPages) {
    state.eventHubPages = eventHubPages;
  },
  setIsLoading(state: State, isLoading: boolean) {
    state.isLoading = isLoading;
  },
  setSearchTerm(state: State, searchTerm: string) {
    state.searchTerm = searchTerm;
  },
  resetEventHubState(state: State) {
    Object.assign(state, getInitialState());
  },
  setCurrentPage(state: State, currentPage: number) {
    state.currentPage = currentPage;
  },
  setEventHubPagesCount(state: State, eventHubPagesCount: number) {
    state.eventHubPagesCount = eventHubPagesCount;
  },
  setEventHubPage(state: State, eventHubPage: EventHubPages[number]) {
    state.eventHubPages[eventHubPage.id] = eventHubPage;
  },
  removeEventHubPage(state: State, pageId: string) {
    delete state.eventHubPages[pageId];
  },
  setEventHubPageParamsState(state: State, params: Params) {
    state.searchTerm = params.searchTerm;
    state.currentPage = params.currentPage;
  },
  setSortBy(state: State, sortBy: SortBy) {
    state.sortBy = sortBy;
  },
  setFilterBy(state: State, filterBy: FilterBy) {
    state.filterBy = filterBy;
  }
};

export default mutations;
